import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Flex } from '@components/layout/Grid';
import RegisterFormTemplate from '@ecosystems/registerForm.pageTemplate';
import { CodeStatusKind, LiveEventKind, LiveEventQuery } from '@gql/generated';

const CodeSection = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
`;

const Paragraph = RegisterFormTemplate.Paragraph;

type Props = {
  liveEvent: Pick<
    LiveEventQuery['liveEvent'],
    | 'kind'
    | 'price'
    | 'paymentKind'
    | 'flexibleMaxAmountCents'
    | 'flexibleMinAmountCents'
  >;
  codeStatus: CodeStatusKind;
};

export const EventPaymentAmount = (props: Props) => {
  const { liveEvent, codeStatus } = props;

  // try to finish this
  if (
    codeStatus !== CodeStatusKind['Valid'] &&
    liveEvent?.kind !== LiveEventKind['DonationClass']
  ) {
  }

  return (
    <>
      <CodeSection>
        {liveEvent?.price?.discountedPrice !== null &&
        liveEvent?.price?.discountedPrice >= 0 ? (
          <Flex justifyContent="space-between">
            <Paragraph size={16} mb={0}>
              <Trans id="live.payment_page.discount_amount" />
            </Paragraph>
            <Paragraph size={18} weight={500} mb={0} color="#418E1C">
              -
              {(liveEvent.price?.originalPrice -
                liveEvent.price?.discountedPrice) /
                100}{' '}
              {liveEvent.price?.currency}
            </Paragraph>
          </Flex>
        ) : null}
        <Flex justifyContent="space-between" data-testid="liveEvent--amount">
          <Paragraph size={16} mb={0}>
            <Trans id="live.payment_page.payment_amount" />:
          </Paragraph>
          <Flex>
            <Paragraph
              size={18}
              weight={500}
              mb={0}
              mr={20}
              crossed={
                liveEvent?.price?.discountedPrice !== null &&
                liveEvent.price?.discountedPrice >= 0
              }
            >
              {liveEvent.price?.originalPrice / 100} {liveEvent.price?.currency}
            </Paragraph>
            {liveEvent?.price?.discountedPrice !== null &&
            liveEvent.price?.discountedPrice >= 0 ? (
              <Paragraph size={18} weight={500} mb={0}>
                {liveEvent.price?.discountedPrice / 100}{' '}
                {liveEvent.price?.currency}
              </Paragraph>
            ) : null}
          </Flex>
        </Flex>
      </CodeSection>
    </>
  );
};
